import React, { useEffect, useRef, useState, useMemo } from "react";
import { useForm } from "react-hook-form";
import EzTable from "../../../common/EzTable";
import { EzToast, TOAST_SEVERITY } from "../../../common/EzToast";
import EzNotFound from "../../../common/EzNotFound";
import { Box, Container, Grid } from "@mui/material";
import Breadcrumb from "../../../common/Breadcrumb";
import { Button } from "primereact/button";
import { useStyles } from "./style";
import EzControlledCalendarWithFloatingLabel from "../../../common/EzForm/EzControlledCalendar/WithFloatingLabel";
import { getFormBaseValidationRule } from "../../../utils/form/form-utils";
import EzControlledInputWithFloatingLabel from "../../../common/EzForm/EzControlledInput/WithFloatingLabel";
import EzControlledDropDowntWithFloatingLabel from "../../../common/EzForm/EzControlledDropDown/WithFloatingLabel";

import EzControlledMultiSelecttWithFloatingLabel from "../../../common/EzForm/EzControlledMultiSelect/WithFloatingLabel";

import {
  bookingTypeDD,
  listStatusDD,
} from "../ReservationsBookingsbyLocationReport/CreateReservationsBookingsbyLocationReport/constant";
import { ReservationsReservationsBreadcrumb } from "../ReservationsReservations/CreateReservationsReservations/constant";
import { getCurrentAndThreeDaysLater } from "../../../utils";
import { printTableData } from "../../../utils/printUtils";

const getIconPath = (imgPathDelta = "/no-record.png") =>
  process.env.PUBLIC_URL + imgPathDelta;
const ReservationsBookingsbyLocationReport = (props) => {
  const classes = useStyles();
  const {
    fetchReservationsBookingsbyLocationReports,
    tableData,
    setDeleteConfirmationPopupVisibility,
    exportReservationsBookingsbyLocationReport,
    isPageLevelError,
    paginationInfo,
    isLoading,
    screenPermissions,
    handleCreateReservationsBookingsbyLocationReport,
    editReservationsBookingsbyLocationReportRoute,
    viewReservationRoute,
    RateNetworkDD,
    locationDD,
    setIsSearch,
    bookingsByLocationFilters,
    setBookingsByLocationFilters,
    clearBookingsByLocationFilters,
  } = props;
  const { currentDate, threeDaysLater } = getCurrentAndThreeDaysLater();
  let customFields = {
    endDate: bookingsByLocationFilters?.endDate || threeDaysLater,
    startDate: bookingsByLocationFilters?.startDate || currentDate,
    location: bookingsByLocationFilters?.location || "",
    network: bookingsByLocationFilters?.network || "",
    status: bookingsByLocationFilters?.status || "",
    type: bookingsByLocationFilters?.type || "bookingDate",
  };
  const {
    control,
    formState: { errors, isDirty },
    watch,
    register,
    handleSubmit,
    reset,
  } = useForm({
    defaultValues: useMemo(() => {
      return customFields;
    }, [bookingsByLocationFilters]),
  });
  const [isCopy, setIsCopy] = useState(false);
  const [isPrintError, setIsPrintError] = useState(false);
  
  // Reset form when filters change (from Redux)
  useEffect(() => {
    if (bookingsByLocationFilters) {
      const { currentDate, threeDaysLater } = getCurrentAndThreeDaysLater();
      reset({
        endDate: bookingsByLocationFilters?.endDate || threeDaysLater,
        startDate: bookingsByLocationFilters?.startDate || currentDate,
        location: bookingsByLocationFilters?.location || "",
        network: bookingsByLocationFilters?.network || "",
        status: bookingsByLocationFilters?.status || "",
        type: bookingsByLocationFilters?.type || "bookingDate",
      });
    }
  }, [bookingsByLocationFilters, reset]);
  
  const convertToTSV = (data) => {
    // Get headers from columns (including ID)
    const headers = data.columns.map((item) => item.colLabel).join("\t");

    // Get rows with values in the same order as columns
    const rows = data.rows
      .map((row) => {
        return data.columns
          .map((col) => {
            const value = row[col.dataKey];
            // Handle null/undefined values
            if (value === null || value === undefined) {
              return "-";
            }
            // Convert to string
            return String(value);
          })
          .join("\t");
      })
      .join("\n");

    return `${headers}\n${rows}`;
  };
  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };
  const copyToClipboard = () => {
    const csv = convertToTSV(tableData);
    navigator.clipboard
      .writeText(csv)
      .then(() => setIsCopy(true))
      .catch((err) => setIsCopy(true));
  };
  useEffect(() => {
    setTimeout(() => setIsCopy(false), 1000);
  }, [isCopy]);
  
  useEffect(() => {
    if (isPrintError) {
      const timer = setTimeout(() => setIsPrintError(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [isPrintError]);
  
  const handlePrint = () => {
    const success = printTableData({
      title: "Bookings by Location Report",
      columns: tableData?.columns || [],
      rows: tableData?.rows || [],
      orientation: "landscape",
    });
    if (!success) {
      setIsPrintError(true);
    }
  };

  const handleExport = () => {
    const exportPayload = {
      additinalFilter: bookingsByLocationFilters,
    };
    exportReservationsBookingsbyLocationReport(exportPayload);
  };
  const renderPageHeaderSection = () => {
    return (
      <div className="make-relative sub-header">
        <div className="maintitlediv">
          <div className="ml-3">
            <h4 className="pagetitle">Bookings by Location Report</h4>
            {/* <Button
             label={areFiltersVisible ? "Advanced Filter" : "Advanced Filter"}
             icon={areFiltersVisible ? "pi pi-filter-slash" : "pi pi-filter"}
             className={`p-button-text p-button-secondary`}
             onClick={() => {
               toggleFilterState(!areFiltersVisible);
             }}
           /> */}
          </div>
          <div className="buttonarea">
            <div className="create-btn-group">
              {/* {
              screenPermissions?.create && (
                <Button
                  label={"Create Reservations Detail Report"}
                  className={` p-button-raised`}
                  style={{ borderRadius: "0px", }}
                  onClick={handleCreateReservationsBookingsbyLocationReport}
                />
              )
            } */}
            </div>
            <div className="copy-excel-print-group">
              <Button
                label={"Copy"}
                className={` p-button-raised`}
                style={{ borderRadius: "0px" }}
                onClick={copyToClipboard}
              />
              <Button
                label={"Excel"}
                className={` p-button-raised`}
                style={{ borderRadius: "0px" }}
                onClick={handleExport}
              />
              <Button
                label={"Print"}
                className={` p-button-raised`}
                style={{ borderRadius: "0px" }}
                onClick={handlePrint}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };
  const shouldRenderFullPageError = () => isPageLevelError;
  const shouldRenderComplianceRecords = () => tableData?.columns?.length > 0;
  const shouldRenderNotFoundView = () =>
    !shouldRenderComplianceRecords() && !shouldRenderFullPageError();
  const filters = {
    global: { value: null },
  };

  const getToastProps = () => {
    let toastTitle = "";
    if (isPrintError) {
      return {
        severity: TOAST_SEVERITY.ERROR,
        toastTitle:
          "Unable to open print window. Please check your popup blocker settings.",
        shouldShowToast: true,
      };
    }
    if (isCopy) {
      let toastTitle = "Data copied to clipboard!";
      if (!isCopy) {
        toastTitle = "Error while Data copied to clipboard!";
      }

      return {
        severity: isCopy ? TOAST_SEVERITY.SUCCESS : TOAST_SEVERITY.ERROR,
        toastTitle,
        shouldShowToast: true,
      };
    }
  };
  const onSubmit = (data) => {
    setBookingsByLocationFilters(data);
    setIsSearch(true);
    fetchReservationsBookingsbyLocationReports({
      pageNumber: 0,
      pageSize: paginationInfo?.pageSize || 10,
      sortField: "id",
      userId: localStorage.getItem("userId"),
      additinalFilter: data,
    });
  };
  
  const handleResetFilters = () => {
    clearBookingsByLocationFilters();
    setIsSearch(false);
    const { currentDate, threeDaysLater } = getCurrentAndThreeDaysLater();
    fetchReservationsBookingsbyLocationReports({
      pageNumber: 0,
      pageSize: paginationInfo?.pageSize || 10,
      sortField: "id",
      userId: localStorage.getItem("userId"),
      additinalFilter: {
        startDate: currentDate,
        endDate: threeDaysLater,
        location: "",
        network: "",
        status: "",
        type: "bookingDate",
      },
    });
  };
  const tableProps = {
    columns: tableData?.columns,
    paginationInfo,
    screenPermissions,
    value: tableData?.rows,
    emptyMessage: "No Bookings by Location Report found.",
    filters,
    loadLazyData: fetchReservationsBookingsbyLocationReports,
    loading: isLoading,
    showMoreActions: false,
    sortField: null,
    setDeleteConfirmationPopupVisibility,
    onEditRecord: editReservationsBookingsbyLocationReportRoute,
    onViewRecord: viewReservationRoute,
    additinalFilter: bookingsByLocationFilters,
    showViewButton: false,
    showEditButton: false,
    showDeleteButton: false,
  };
  return (
    <>
      <Container maxWidth="lg">
        <Breadcrumb list={ReservationsReservationsBreadcrumb} />
        <EzToast {...getToastProps()} />
        <div className={`containerbox ${classes.bg}`}>
          {renderPageHeaderSection()}

          <div className="form-demo">
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <EzControlledCalendarWithFloatingLabel
                    id="startDate"
                    name="startDate"
                    {...register("startDate")}
                    showTime={false}
                    maxDate={new Date(2090, 0, 1)}
                    dateFormat="yy/mm/dd"
                    control={control}
                    isError={errors["startDate"]}
                    errorMsg={getFormErrorMessage("startDate")}
                    label="Start Date"
                    rules={getFormBaseValidationRule().DEFAULT.VALIDATION_RULE}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <EzControlledCalendarWithFloatingLabel
                    id="endDate"
                    name="endDate"
                    {...register("endDate")}
                    showTime={false}
                    maxDate={new Date(2090, 0, 1)}
                    dateFormat="yy/mm/dd"
                    control={control}
                    isError={errors["endDate"]}
                    errorMsg={getFormErrorMessage("endDate")}
                    label="End Date"
                    rules={getFormBaseValidationRule().DEFAULT.VALIDATION_RULE}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <EzControlledDropDowntWithFloatingLabel
                    name="type"
                    control={control}
                    rules={getFormBaseValidationRule().DEFAULT.VALIDATION_RULE}
                    optionLabel={"name"}
                    optionValue={"id"}
                    options={bookingTypeDD}
                    isError={errors["type"]}
                    errorMsg={getFormErrorMessage("type")}
                    label="Type"
                    labelClassName={"ml-2"}
                />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <EzControlledMultiSelecttWithFloatingLabel
                    name="location"
                    control={control}
                    rules={getFormBaseValidationRule().DEFAULT.DO_NOT_VALIDATE}
                    optionLabel={"name"}
                    optionValue={"id"}
                    options={locationDD}
                    isError={errors["location"]}
                    errorMsg={getFormErrorMessage("location")}
                    label="Location"
                    labelClassName={"ml-2"}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <EzControlledMultiSelecttWithFloatingLabel
                    name="network"
                    control={control}
                    rules={getFormBaseValidationRule().DEFAULT.DO_NOT_VALIDATE}
                    optionLabel={"name"}
                    optionValue={"id"}
                    options={RateNetworkDD}
                    isError={errors["network"]}
                    errorMsg={getFormErrorMessage("network")}
                    label="Network"
                    labelClassName={"ml-2"}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <div
                    style={{ margin: "0px 0px 10px 10px", maxWidth: "200px", display: "flex", gap: "10px" }}
                  >
                    <Button
                      type="button"
                      label={"Search"}
                      className="p-button-raised"
                      onClick={handleSubmit(onSubmit)}
                    />
                    <Button
                      type="button"
                      label={"Reset"}
                      className="p-button-raised p-button-secondary"
                      onClick={handleResetFilters}
                    />
                  </div>
                </Grid>
              </Grid>
            </form>
          </div>
          <div className="mTop15">
            {shouldRenderFullPageError() && (
              <EzNotFound
                messageStyle={{ marginLeft: "-70px" }}
                bgImgUrl={getIconPath("something-broke.png")}
                message={"Oops! Something broke, we are working on a fix."}
              />
            )}
            {shouldRenderComplianceRecords() && (
              <Box id="printable">
                <EzTable {...tableProps} />
              </Box>
            )}
            {shouldRenderNotFoundView() && (
              <EzNotFound
                bgImgUrl={getIconPath()}
                message={"No Bookings by Location Report records to show"}
              />
            )}
          </div>
        </div>
      </Container>
    </>
  );
};
export default ReservationsBookingsbyLocationReport;
